import { render, staticRenderFns } from "./TasksLandingPage.vue?vue&type=template&id=f40699f0"
import script from "./TasksLandingPage.vue?vue&type=script&lang=js"
export * from "./TasksLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports